import {
  ADD_SHIFT_SUCCESS,
  ADD_SHIFT_FAIL,
  GET_SHIFTS_SUCCESS,
  GET_SHIFTS_FAIL,
  UPDATE_SHIFT_SUCCESS,
  UPDATE_SHIFT_FAIL,
  DELETE_SHIFT_SUCCESS,
  DELETE_SHIFT_FAIL,
  ADD_SHIFT,
  SHIFT_LOGS_SUCCESS,
  SHIFT_LOGS_FAIL,
  SHIFT_REPORT_SUCCESS,
  SHIFT_REPORT_FAIL,
  GET_SHIFTS,
  CANCEL_SHIFT_ADMIN_SUCCESS,
  CANCEL_SHIFT_ADMIN_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  shiftRes: [],
  error: [],
  shifts: [],
  list: [],
  report: [],
  loading: false,
};

const ShiftReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CANCEL_SHIFT_ADMIN_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case CANCEL_SHIFT_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SHIFT_REPORT_SUCCESS:
      return {
        ...state,
        report: action.payload,
      };
    case SHIFT_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_SHIFT_SUCCESS:
      return {
        ...state,
        shiftRes: action.payload,
      };
    case DELETE_SHIFT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SHIFT_LOGS_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case SHIFT_LOGS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_SHIFT_SUCCESS:
      return {
        ...state,
        shiftRes: action.payload,
      };
    case UPDATE_SHIFT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_SHIFTS:
      return {
        ...state,
        loading: true,
      };
    case GET_SHIFTS_SUCCESS:
      return {
        ...state,
        loading: false,
        shifts: action.payload,
      };
    case GET_SHIFTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD_SHIFT_SUCCESS:
      return {
        ...state,
        shiftRes: action.payload,
      };
    case ADD_SHIFT:
      return {
        ...state,
        error: [],
      };
    case ADD_SHIFT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default ShiftReducer;
